<template>
  <div v-if="sectionsByKey">
    <v-container>
      <v-row>
        <div
          class="d-flex justify-space-between mb-6"
          style="width: 100%;"
        >
          <SectionTitle :title="$t('main.enums.sections.personal_infos')" />
        </div>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            v-if="sectionsByKey.personal_information.isVisible"
            :section-number="sectionsByKey.personal_information.number"
            :title="$t('main.enums.sections.personal_information')"
          />
        </v-col>
      </v-row>
      <v-row class="flex-grow-1">
        <v-col
          md="12"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['civility']"
            :isError="checks.civility"
            :label="$t('main.enums.fields.civility')"
            :value="selectedProfile.civility ? $t(`main.enums.civility.${selectedProfile.civility}`) : ''"
            color="purple"
          />
        </v-col>
        <v-col
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['first_name']"
            :isError="checks.first_name"
            :label="$t('main.enums.fields.first_name')"
            :value="selectedProfile.first_name"
            color="purple"
          />
        </v-col>
        <v-col
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['last_name']"
            :isError="checks.last_name"
            :label="$t('main.enums.fields.last_name')"
            :value="selectedProfile.last_name"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['birth_name']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['birth_name']"
            :isError="checks.birth_name"
            :label="$t('main.enums.fields.birth_name')"
            :value="selectedProfile.birth_name"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['other_names']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['other_names']"
            :isError="checks.other_names"
            :label="$t('main.enums.fields.other_names')"
            :value="selectedProfile.other_names"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['date_of_birth']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['date_of_birth']"
            :isError="checks.date_of_birth"
            :label="$t('main.enums.fields.date_of_birth')"
            :value="selectedProfileAge"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['birth_country']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['birth_country']"
            :isError="checks.birth_country"
            :label="$t('main.enums.fields.birth_country')"
            :value="selectedProfile.birth_country"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayBirthCity && displayField['birth_insee_code']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['birth_insee_code']"
            :isError="checks.birth_insee_code"
            :label="$t('main.enums.fields.birth_insee_code')"
            :value="selectedBirthCity"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['nationalities']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['nationalities']"
            :isError="checks.nationalities"
            :label="$t('main.enums.fields.nationalities')"
            :value="selectedProfileNationalities"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayPermitNumber && displayField['residence_permit_number']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['residence_permit_number']"
            :isError="checks.residence_permit_number"
            :label="$t('main.enums.fields.residence_permit_number')"
            :value="selectedProfile.residence_permit_number"
            color="purple"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            v-if="sectionsByKey.marital_infos.isVisible"
            :section-number="sectionsByKey.marital_infos.number"
            :title="$t('main.enums.sections.marital_infos')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="displayField['marital_status']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['marital_status']"
            :isError="checks.marital_status"
            :label="$t('main.enums.fields.marital_status')"
            :value="$t(`main.enums.marital_status.${selectedProfile.marital_status}`)"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="selectedProfile.marital_status === 'married'"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['matrimonial_regime']"
            :isError="checks.matrimonial_regime"
            :label="$t('main.enums.fields.matrimonial_regime')"
            :value="
              selectedProfile.matrimonial_regime
                ? $t(`main.enums.matrimonial_regime.${selectedProfile.matrimonial_regime}`)
                : ''
            "
            color="purple"
          />
        </v-col>
        <v-col
          v-if="selectedProfile.marital_status === 'pacs'"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            v-if="selectedProfile.pacs_convention"
            :isRequired="isRequired['pacs_convention']"
            :isError="checks.pacs_convention"
            :label="$t('main.enums.fields.pacs_convention')"
            :value="
              selectedProfile.pacs_convention
                ? $t(`main.enums.pacs_convention.${selectedProfile.pacs_convention}`)
                : ''
            "
            color="purple"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            v-if="sectionsByKey.professional_infos.isVisible"
            :section-number="sectionsByKey.professional_infos.number"
            :title="$t('main.enums.sections.professional_infos')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="displayField['profession']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['profession']"
            :isError="checks.profession"
            :label="$t('main.enums.fields.profession')"
            :value="selectedProfile.profession"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['profession_sector']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['profession_sector']"
            :isError="checks.profession_sector"
            :label="$t('main.enums.fields.profession_sector')"
            :value="selectedProfile.profession_sector"
            color="purple"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          class="mb-1"
        >
          <SmallSectionTitle
            v-if="sectionsByKey.tax_infos.isVisible"
            :section-number="sectionsByKey.tax_infos.number"
            :title="$t('main.enums.sections.tax_infos')"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="displayField['reference_tax_number']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['reference_tax_number']"
            :isError="checks.reference_tax_number"
            :label="$t('main.enums.fields.reference_tax_number')"
            :value="selectedProfile.reference_tax_number"
            color="purple"
            :tooltipText="$t('hints.reference_tax_number')"
          />
        </v-col>
        <v-col
          v-if="displayField['tax_address_line_1']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['tax_address_line_1']"
            :isError="checks.tax_address_line_1"
            :label="$t('main.enums.fields.tax_address_line_1')"
            :value="selectedProfile.tax_address_line_1"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['tax_address_line_2']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['tax_address_line_2']"
            :isError="checks.tax_address_line_2"
            :label="$t('main.enums.fields.tax_address_line_2')"
            :value="selectedProfile.tax_address_line_2"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['tax_address_line_3']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['tax_address_line_3']"
            :isError="checks.tax_address_line_3"
            :label="$t('main.enums.fields.tax_address_line_3')"
            :value="selectedProfile.tax_address_line_3"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayField['tax_country']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['tax_country']"
            :isError="checks.tax_country"
            :label="$t('main.enums.fields.tax_country')"
            :value="selectedProfile.tax_country"
            color="purple"
          />
        </v-col>
        <v-col
          v-if="displayTaxCity && displayField['tax_insee_code']"
          md="6"
          cols="12"
        >
          <LabelledFieldAlt
            :isRequired="isRequired['tax_insee_code']"
            :isError="checks.tax_insee_code"
            :label="$t('main.enums.fields.tax_insee_code')"
            :value="selectedTaxCity"
            color="purple"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import CommonMixin from '@/mixins/store/CommonMixin.js'
  import { getFieldsByProperty } from '@/utils/person.utils'

  import SmallSectionTitle from '@/components/ui/common/SmallSectionTitle'
  import SectionTitle from '@/components/ui/common/SectionTitle'
  import LabelledFieldAlt from '@/components/ui/common/LabelledFieldAlt'

  import personTabFields from '@/components/RightDrawer/helpers/PersonTab.fields.json'
  import { getVisibleSections } from '@/components/RightDrawer/helpers/PersonTab.helper'
  import { byKey } from '@/utils/common.utils'

  export default {
    components: {
      SectionTitle,
      SmallSectionTitle,
      LabelledFieldAlt,
    },
    mixins: [mixinUi, CommonMixin,],
    data() {
      return {
        localFields: personTabFields.perso,
        checks: {},
      }
    },
    computed: {
      sectionsByKey() {
        const sectionKeys = ['personal_information', 'marital_infos', 'professional_infos', 'tax_infos',]
        const visibleSections = getVisibleSections(
          this.requiredAttributes,
          this.optionalAttributes,
          'perso',
          sectionKeys
        )
        const sectionsByKey = byKey(visibleSections, 'key')

        return sectionsByKey
      },
      displayField() {
        const allFields = this.requiredAttributes.concat(this.optionalAttributes)

        return getFieldsByProperty(allFields, this.localFields)
      },
      isRequired() {
        return getFieldsByProperty(this.requiredAttributes, this.localFields)
      },
      selectedProfileAge() {
        if (!this.selectedProfile.date_of_birth) {
          return null
        }
        const ageDifMs = Date.now() - new Date(this.selectedProfile.date_of_birth).getTime()
        const ageDate = new Date(ageDifMs)
        const age = Math.abs(ageDate.getUTCFullYear() - 1970)

        return `${this.$d(new Date(this.selectedProfile.date_of_birth))}
        (${this.$tc('main.form.age', age, { nb: age, })})`
      },
      selectedProfileNationalities() {
        if (this.selectedProfile.nationalities && this.selectedProfile.nationalities.length > 0) {
          return this.selectedProfile.nationalities.join(',')
        } else {
          return ''
        }
      },
      selectedBirthCity() {
        if (this.selectedProfile.birth_insee_code === null) {
          return null
        }
        const cities = this.currentConfig.enums.french_cities_with_state
        const city = cities[this.selectedProfile.birth_insee_code]

        return city ? `${String(city.dep).padStart(2, '0')} - ${city.libelle}` : null
      },
      selectedTaxCity() {
        if (this.selectedProfile.tax_insee_code === null) {
          return null
        }
        const cities = this.currentConfig.enums.french_cities_with_state
        const city = cities[this.selectedProfile.tax_insee_code]

        return city ? `${String(city.dep).padStart(2, '0')} - ${city.libelle}` : null
      },
      displayPermitNumber() {
        return (
          this.selectedProfile.nationalities &&
          !this.selectedProfile.nationalities.find((item) => item === 'FRANCE')
        )
      },
      displayBirthCity() {
        return this.selectedProfile.birth_country === 'FRANCE'
      },
      displayTaxCity() {
        return this.selectedProfile.tax_country === 'FRANCE'
      },
    },
    mounted() {
      this.checks = this.selectedProfile.person_controls[0].checks
    },
  }
</script>
